import { useQuery } from '@tanstack/react-query';
import type { ModelDefinition } from '@mem-ai-hub/shared';
import { getModels } from '@/services/modelApi';

export function useModels() {
  const { data, isLoading, error } = useQuery<ModelDefinition[]>({
    queryKey: ['models'],
    queryFn: getModels,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  return {
    models: data ?? [],
    isLoading,
    error,
  };
}
